import styled from '@emotion/styled';
import {
  Avatar as _Avatar,
  ListItemIcon as _ListItemIcon,
  ListItemText,
  MenuItem,
  Select as _Select,
  Tab as _Tab,
  Tabs as _Tabs,
  useMediaQuery,
} from '@material-ui/core';
import { createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { MaterialTypeDefinition } from '../../../../entity/SearchAsset';
import { SubType } from '../../../../hooks/SearchAsset/useTypeAndSubType';
import theme from '../../../../theme';

type Props = {
  materialType: MaterialTypeDefinition;
  subType: SubType;
  subTypes: ReadonlyArray<SubType>;
  resetSearch: () => void;
  scrollToTop: () => void;
  handleChange: (newSubTypeIndex: number) => void;
};

export const SubTypeTab = ({ materialType, subType, subTypes, resetSearch, scrollToTop, handleChange }: Props) => {
  const handleClickTab = (_: unknown, nextIndex: number) => {
    scrollToTop();
    resetSearch();
    handleChange(nextIndex);
  };

  const isPC = useMediaQuery(`(min-width:${theme.breakpoints.values['lg']}px)`);

  const getSubTypeText = (subType: SubType) => {
    if (materialType.name !== 'audio') {
      return <FormattedMessage id={`search_file_uploader.material_type.subtype.${subType.name.toLowerCase()}`} />;
    } else {
      if (subType.isRecommend) {
        return <FormattedMessage id="search_file_uploader.material_type.subtype.recommend" />;
      } else {
        return <FormattedMessage id={`search_file_uploader.material_type.audio.${subType.name}_text`} />;
      }
    }
  };

  return (
    <Root>
      {isPC ? (
        <Tabs orientation="vertical" value={subType.index} onChange={handleClickTab}>
          {subTypes.map((subType) => (
            <Tab
              key={subType.index}
              label={getSubTypeText(subType)}
              icon={
                materialType.name !== 'audio' ? (
                  <Avatar src={`/assets/${subType.name.toLowerCase()}_text_logo.png`} />
                ) : undefined
              }
            />
          ))}
        </Tabs>
      ) : (
        <Select
          id="select"
          value={subType.name}
          onChange={(e) => {
            const target = e.currentTarget as HTMLSelectElement;
            const index = Number(target.attributes['data-index' as any].value);
            handleClickTab(null, index);
          }}
        >
          {[
            ...subTypes.map((subType) => {
              return (
                <MenuItem data-name={subType.name} data-index={subType.index} key={subType.index} value={subType.name}>
                  <LiteItemContent>
                    {materialType.name !== 'audio' ? (
                      <ListItemIcon>
                        <Avatar src={`/assets/${subType.name.toLowerCase()}_text_logo.png`} />
                      </ListItemIcon>
                    ) : null}
                    <ListItemText primary={getSubTypeText(subType)} />
                  </LiteItemContent>
                </MenuItem>
              );
            }),
          ]}
        </Select>
      )}
    </Root>
  );
};

const Root = styled('div')``;

const Tabs = styled(_Tabs)`
  .MuiTab-wrapper {
    flex-direction: row;
  }

  .MuiTabs-indicator {
    left: 0;
  }

  .MuiAvatar-img {
    width: initial;
    height: initial;
    padding-top: 6px;
  }
`;

const Tab = styled(_Tab)`
  text-transform: none;
`;

const Select = styled(_Select)`
  width: 100%;
`;

const LiteItemContent = styled('div')`
  ${theme.breakpoints.down('md')} {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: auto 0;
  }
`;

const ListItemIcon = styled(_ListItemIcon)`
  min-width: 40px;
`;

const Avatar = styled(_Avatar)`
  width: 30px;
  height: 30px;
  img {
    ${theme.breakpoints.down('sm')} {
      width: auto;
      height: auto;
      object-fit: contain;
    }
  }
`;
